import { useGetThicknessClassQuery, useGetThicknessClassPresentationQuery } from "../../../../timber/apis/ThicknessClass.api";
import { ThicknessClassNameDisplay } from "../../../../timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassName";
import { toString as toStringThicknessClass, PrimaryThicknessClass } from "../../../../timber/types/models/ThicknessClass";
import * as crudgen from "../../../../share";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import { Button, IconButton, Stack, Dialog, DialogTitle, DialogContent } from '@mui/material';
import { Add as AddIcon } from "@mui/icons-material";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";
import {ID} from "../../../../types/global.d";
import {useLocationFormState} from "./ThicknessClassAddForm";
import ThicknessClassAddFormProvider from "./ThicknessClassAddFormProvider";

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import {DescriptionAlert} from "../../../../share";
import { useFormContext } from 'react-hook-form';
import {useStateSession} from "../../../../hooks/useAuth";

const EMPTY_PAGINATION = {
    items: [],
    totalItems: 0,
    page: 0,
    pageSize: 12,
    numPages: 0
}

const AddDialog = ({name}) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [showDialog, setShowDialog] = React.useState<boolean>(false)
    const {setValue} = useFormContext()

    return (
        <>
            <IconButton aria-label={ t`Add Thickness Class` } onClick={() => setShowDialog(true)} size="small">
                <AddIcon />
            </IconButton>
            <Dialog
                open={showDialog}
                fullScreen={fullScreen}
                onClose={() => setShowDialog(false)}>
                <DialogTitle><Trans>Add Thickness Class</Trans></DialogTitle>
                <DialogContent>
                    <DescriptionAlert/>
                    <ThicknessClassAddFormProvider
                        successAction={
                            (data) => {
                                setValue(name, data.id)
                                setShowDialog(false)
                            }
                        }
                        cancelButton={<Button onClick={() => setShowDialog(false)}><Trans>Cancel</Trans></Button>}
                        initialFormState={useLocationFormState}
                        redirectPath="."
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}

const ThicknessClassFormSelect = ({type, name, label, prefix, required, onValueChange, filter = {}} :
                                        {type: string, name: string, label: string, prefix: string, required: boolean, onValueChange?: (option: any) => void, filter: {
                                                name: string,
                                                classId: ID,
                                                }
                                        })  => {

    const session = useStateSession()
    const [, setInputTerm, inputTerm] = useSearchDebounce();

    const { data = EMPTY_PAGINATION,
        isLoading,
        isFetching,
    } = useGetThicknessClassPresentationQuery({
      list: {
        page: 0,
        pageSize: 12,
      },
      filter: {
            name: inputTerm || '',
            nameOr: true,
            ...filter,
      },
    })

    if (type === 'select') {
        return (
            <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
                <crudgen.AsyncFormSelect
                   required={ required }
                   name={ prefix + name }
                   aria-label={ label }
                   label={ label }
                   optionsLoading={ isLoading || isFetching }
                   options={ data.items }
                   valueMap={ (id) => useGetThicknessClassQuery(PrimaryThicknessClass.fromId(id), {skip: !id}) }
                   optionLabelMap={ toStringThicknessClass }
                   onInputChange={ setInputTerm }
                   onValueChange={ onValueChange }
                   renderOption={ (optionProps, option, { inputValue }) => <li {...optionProps}><ThicknessClassNameDisplay data={option}/></li> }
                />
                { session.hasPermission('', 'applications/timber/entities/ThicknessClasses/write/view') &&
                    <AddDialog name={name}/>
                }
            </Stack>
        )
    } else {
        return (
            <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
                <crudgen.AsyncFormSelect
                   required={ required }
                   name={ prefix + name }
                   aria-label={ label }
                   label={ label }
                   optionsLoading={ isLoading || isFetching }
                   options={ data.items }
                   valueMap={ (id) => useGetThicknessClassQuery(PrimaryThicknessClass.fromId(id), {skip: !id}) }
                   optionLabelMap={ toStringThicknessClass }
                   onInputChange={ setInputTerm }
                   onValueChange={ onValueChange }
                   renderOption={ (optionProps, option, { inputValue }) => <li {...optionProps}><ThicknessClassNameDisplay data={option}/></li> }
                />
                { session.hasPermission('', 'applications/timber/entities/ThicknessClasses/write/view') &&
                    <AddDialog name={name}/>
                }
            </Stack>
        )
    }
}

export default ThicknessClassFormSelect